module.exports = __webpack_public_path__ + "img/grip-lines-vertical.f74fa46f.svg";